import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../../@types";
import { RootState } from "../../app/store";
import { AuthPermission, AuthUser } from "./@types";

const initialState: AuthState = {
  userDetails: null,
  permissions: [],
  isLoading: false,
  isAuthenticated: false,
  token: null,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        accessToken: string;
        user: AuthUser;
        permissions: AuthPermission[];
      }>
    ) => {
      const { user, permissions, accessToken } = action.payload;
      state.userDetails = user;
      state.permissions = permissions;
      state.token = accessToken;
      state.isAuthenticated = true;
      state.error = null;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setUser: (state, action: PayloadAction<AuthUser>) => {
      state.userDetails = action.payload;
      state.isAuthenticated = true;
    },
    setPermissions: (state, action: PayloadAction<AuthPermission[]>) => {
      state.permissions = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    logOut: (state) => {
      state.userDetails = null;
      state.permissions = [];
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
    },
  },
});

export const {
  setCredentials,
  setToken,
  setUser,
  setPermissions,
  setLoading,
  setError,
  logOut,
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state: { auth: AuthState }) =>
  state.auth.token;
export const selectCurrentUser = (state: RootState) => state.auth.userDetails;
export const selectUserPermissions = (state: RootState) =>
  state.auth.permissions;
export const selectAuthLoading = (state: RootState) => state.auth.isLoading;
export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;
export const selectAuthError = (state: RootState) => state.auth.error;
